import { Member } from './member.model';

export class UpdateMembersCommand {
    MembersToUpdate: Array<Member>;
}
